/** @jsxImportSource @emotion/react */
import React from 'react';

import {css} from '@emotion/react';

import WifiDisableIcon from '@/assets/icons/SystemSettingsWifiDisable.svg';
import {fontSize, LAYOUT} from '@/constants/appStyle';
import {FONT_SIZE as FontSize} from '@/constants/pcConstAppData';

// TODO need to change this into (generic component | pure component) of wifi system settings cause of same component style
function NotAvailableWifiList() {
  const NotAvailableWifiListStyle = css({
    height: `calc(${LAYOUT.heightResolution} - (${LAYOUT.bottomMenuHeight} + ${LAYOUT.topMenuHeight}))`,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',

    p: {
      color: 'grey',
      margin: '20px',
      fontSize: parseInt(window.localStorage.getItem(FontSize), 10) || fontSize,
    },
  });

  return (
    <div css={NotAvailableWifiListStyle}>
      <img
        src={WifiDisableIcon}
        alt={WifiDisableIcon}
      />
      <p>No wifi networks available</p>
    </div>
  );
}
export default React.memo(NotAvailableWifiList);
